module.exports = __webpack_public_path__ + "static/img/err-8.715f454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/err-8.png
// module id = +dnp
// module chunks = 1